<div class="container-fluid special-content">
  <div class="container text-center my-4 new-home-content">
    <!-- Heading -->
    <h5 class="interests-heading" role="heading" aria-level="2">{{ 'Explore Your Special Interests' | translate }}</h5>
    <!-- Top divider -->
    <div class="section-dividers">
      <div class="divider-line"></div>
      <div class="divider-gap"></div>
      <div class="divider-line"></div>
    </div>

    <!-- Cards -->
    <div class="interests-container">
      <div class="interest-card" (click)="navigateTo('sailing')">
        <div class="interest-title">{{ 'Sailing' | translate }}</div>
        <!-- <img [src]="sailingImageUrl" alt="Sailing" /> -->
        <img
          [src]="sailingImage240"
          [attr.srcset]="sailingImage240 + ' 240w, ' + sailingImage480 + ' 480w, ' + sailingImage720 + ' 720w'"
          sizes="212px"
          width="212"
          height="135"
          loading="lazy"
          decoding="async"
          alt="Sailing"
        />
      </div>
      <div class="interest-card" (click)="navigateTo('romance')">
        <div class="interest-title">{{ 'Romance' | translate }}</div>
        <!-- <img [src]="romanceImageUrl" alt="Romance" /> -->
        <img
          [src]="romanceImage240"
          [attr.srcset]="romanceImage240 + ' 240w, ' + romanceImage480 + ' 480w, ' + romanceImage720 + ' 720w'"
          sizes="212px"
          width="212"
          height="135"
          loading="lazy"
          decoding="async"
          alt="Romance"
        />
      </div>
      <div class="interest-card" (click)="navigateTo('diving')">
        <div class="interest-title">{{ 'Diving' | translate }}</div>
        <!-- <img [src]="divingImageUrl" alt="Diving" /> -->
        <img
          [src]="divingImage240"
          [attr.srcset]="divingImage240 + ' 240w, ' + divingImage480 + ' 480w, ' + divingImage720 + ' 720w'"
          sizes="212px"
          width="212"
          height="135"
          loading="lazy"
          decoding="async"
          alt="Diving"
        />
      </div>
      <div class="interest-card" (click)="navigateTo('nature')">
        <div class="interest-title">{{ 'Nature' | translate }}</div>
        <!-- <img [src]="natureImageUrl" alt="Nature" /> -->
        <img
          [src]="natureImage240"
          [attr.srcset]="natureImage240 + ' 240w, ' + natureImage480 + ' 480w, ' + natureImage720 + ' 720w'"
          sizes="212px"
          width="212"
          height="135"
          loading="lazy"
          decoding="async"
          alt="Nature"
        />
      </div>
      <div class="interest-card" (click)="navigateTo('culture')">
        <div class="interest-title">{{ 'Culture' | translate }}</div>
        <!-- <img [src]="cultureImageUrl" alt="Culture" /> -->
        <img
          [src]="cultureImage240"
          [attr.srcset]="cultureImage240 + ' 240w, ' + cultureImage480 + ' 480w, ' + cultureImage720 + ' 720w'"
          sizes="212px"
          width="212"
          height="135"
          loading="lazy"
          decoding="async"
          alt="Culture"
        />
      </div>
      <div class="interest-card" (click)="navigateTo('sustainable_seychelles')">
        <div class="interest-title Sustainable-title">
          {{ 'Sustainable Seychelles' | translate }}
        </div>
        <!-- <img [src]="sustainableImageUrl" alt="Sustainable" /> -->
        <img
          [src]="sustainableImage240"
          [attr.srcset]="
            sustainableImage240 + ' 240w, ' + sustainableImage480 + ' 480w, ' + sustainableImage720 + ' 720w'
          "
          sizes="212px"
          width="212"
          height="135"
          loading="lazy"
          decoding="async"
          alt="Sustainable"
        />
      </div>
      <div class="interest-card" (click)="navigateTo('fishing')">
        <div class="interest-title">{{ 'Fishing' | translate }}</div>
        <!-- <img [src]="fishingImageUrl" alt="Fishing" /> -->
        <img
          [src]="fishingImage240"
          [attr.srcset]="fishingImage240 + ' 240w, ' + fishingImage480 + ' 480w, ' + fishingImage720 + ' 720w'"
          sizes="212px"
          width="212"
          height="135"
          loading="lazy"
          decoding="async"
          alt="Fishing"
        />
      </div>
    </div>

    <!-- Bottom divider (same as top) -->
    <div class="section-dividers mb-4">
      <div class="divider-line"></div>
      <div class="divider-gap"></div>
      <div class="divider-line"></div>
    </div>
  </div>
</div>
